import { Store } from 'libx';
import { computed, observable, action } from 'mobx';
import { INFO_EVENTS } from 'shared/dictionaries/events';

export default class AppStore extends Store {

  widgetKind = 'info';

  @observable isLoading = false;
  @observable allCollapsed = false;
  @observable hasApiError = false;
  @observable isOriginError = false;
  @observable isTooManyRequests = false;
  @observable retryAfter = 0;

  @computed
  get hasLoadingError() {
    return !this.isLoading && !!this.hasApiError;
  }

  get hasData() {
    return !this.isLoading && this.dataStore.codes.length > 0;
  }

  @computed
  get queryParamsStore() {
    return this.rootStore.queryParamsStore;
  }

  @computed
  get countryStore() {
    return this.rootStore.countryStore;
  }

  @computed
  get apiKey() {
    return this.queryParamsStore.apiKey;
  }

  @computed
  get dominantMode(){
    return this.queryParamsStore.dominantMode; 
  }

  @computed
  get code() {
    return this.queryParamsStore.code;
  }

  @computed
  get treeLink() {
    return this.queryParamsStore.treeLink;
  }

  @computed
  get treeLinkTarget() {
    return this.queryParamsStore.treeLinkTarget;
  }

  @computed
  get theme() {
    return this.queryParamsStore.theme;
  }

  @computed
  get dataStore() {
    return this.queryParamsStore.dataStore;
  }

  @computed
  get onDate() {
    return this.queryParamsStore.date;
  }
  set onDate(value) {
    this.queryParamsStore.date = value;
  }

  @computed
  get direction(){
    return this.queryParamsStore.direction;
  }
  set direction(value){
    this.queryParamsStore.direction = value;
  }

  @computed
  get clearanceCountry() {
    return this.queryParamsStore.clearanceCountry;
  }
  set clearanceCountry(value) {
    this.queryParamsStore.clearanceCountry = value;
  }
  
  @computed
  get originCountry() {
    return this.queryParamsStore.originCountry;
  }
  set originCountry(value) {
    this.queryParamsStore.originCountry = value;
  }

  @computed
  get countries() {
    return this.countryStore.countries;
  }
  
  @computed
  get isLoadCountries() {
    return this.countryStore.isLoadCountries;
  }

  @computed
  get showTitle() {
    return this.queryParamsStore.showTitle;
  }

  @computed
  get collapsedByDefault() {
    return this.queryParamsStore.collapsed;
  }

  @action.bound
  showApiError({ code, text, body, retryAfter }) {
    this.hasApiError = true;

    if (code === 406) {
      this.isOriginError = true;
    }

    if(code === 429) {
      this.isTooManyRequests = true;
      this.retryAfter = retryAfter;
    }
  }

  @action.bound
  clearApiErrors() {
    this.hasApiError = false;
    this.isOriginError = false;
    this.isTooManyRequests = false;
    this.retryAfter = 0;
  }

  sendEvent(name, details) {
    if (INFO_EVENTS.includes(name) && window.parent && typeof window.parent.postMessage === 'function') {
      window.parent.postMessage({ name, details }, '*');
    }
  }

}




// WEBPACK FOOTER //
// ./src/stores/AppStore.js